import React from 'react';
import './home.css';

const services = [
    {
        title: 'IT Consultation',
        description:
            'Practical guidance for architecture, tooling, and operational decisions so your systems stay reliable and scalable.',
    },
    {
        title: 'Design Services',
        description:
            'Interface and product design for websites, dashboards, and internal tools with a clear user focus.',
    },
    {
        title: 'Programming and IT Solutions',
        description:
            'Custom development for web projects, automations, and other IT-related services tailored to your business needs.',
    },
    {
        title: 'Game Server Hosting Services',
        description:
            'Experience with game server hosting environments, troubleshooting, and operations, with readiness to contribute as part of a hosting support team.',
    },
];

const highlights = [
    'IT services with technical depth',
    'Design and engineering in one workflow',
];

const HomePage = () => {
    return (
        <main className="home-page">
            <section className="hero-panel">
                <p className="eyebrow">BrogVerse</p>
                <h1>IT services for modern businesses.</h1>
                <p className="hero-copy">
                    BrogVerse offers IT consultation, design, programming, and game server
                    hosting services to help companies launch and improve their digital presence.
                </p>

                <div className="hero-actions">
                    <a className="secondary-cta" href="/redirects">
                        Explore Service Links
                    </a>
                </div>

                <ul className="highlights-list">
                    {highlights.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
            </section>

            <section className="services-section" aria-label="Core services">
                {services.map((service) => (
                    <article key={service.title} className="service-card">
                        <h2>{service.title}</h2>
                        <p>{service.description}</p>
                    </article>
                ))}
            </section>

            <section className="proof-strip" aria-label="Company proof points">
                <div>
                    <p className="proof-number">Consult</p>
                    <p className="proof-label">Clear technical direction</p>
                </div>
                <div>
                    <p className="proof-number">Design</p>
                    <p className="proof-label">Thoughtful and practical product experience</p>
                </div>
                <div>
                    <p className="proof-number">Build</p>
                    <p className="proof-label">Programming for real-world needs</p>
                </div>
            </section>
        </main>
    );
};

export default HomePage;